import { SelectChangeEvent, SelectProps } from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import { FC } from "react";
import { COLOR_BLACK, COLOR_GREY_8, COLOR_GREY_9 } from "shared/theme/colors";
import FieldContainer from "../components/FieldContainer";
import FieldLabel from "../components/FieldLabel";
import { StyledMenuItem, StyledNativeSelect } from "./styled";

export type SelectOption = {
  value: string;
  label: string;
  disabled?: boolean;
};

type SelectType = SelectProps & {
  label?: string;
  labelColor?: string;
  className?: string;
  value?: string;
  handleChange?: (value: string) => void;
  disabledPlaceholder?: boolean;
  disabled?: boolean;
  options?: SelectOption[];
  isHiddenPlaceholder?: boolean;
  defaultValue?: string;
  placeholder?: string;
};

const Select: FC<SelectType> = (props) => {
  const {
    handleChange,
    disabledPlaceholder,
    placeholder = "Select",
    disabled,
    labelColor = COLOR_BLACK,
    isHiddenPlaceholder,
    value = "",
    ...rest
  } = props;

  return (
    <FieldContainer className={props.className} disabled={disabled}>
      <FieldLabel
        label={props.label}
        labelColor={disabled ? COLOR_GREY_9 : labelColor}
        fontWeight={500}
      />
      <StyledNativeSelect
        variant="filled"
        filled={value ? 1 : 0}
        disableUnderline
        onChange={(event: SelectChangeEvent<unknown>) =>
          handleChange?.(event.target.value as string)
        }
        value={value}
        displayEmpty
        renderValue={(selectedValue: unknown) => {
          if (!selectedValue) {
            return (
              <Typography color={COLOR_GREY_8} variant="bodyMRegular">
                {placeholder}
              </Typography>
            );
          }
          return (
            <>
              {
                props.options?.find((option) => option.value === selectedValue)
                  ?.label
              }
            </>
          );
        }}
        {...rest}
      >
        {props.options?.map(({ value: optionValue, label, disabled }) => (
          <StyledMenuItem
            key={optionValue}
            value={optionValue}
            disabled={disabled}
          >
            {label}
          </StyledMenuItem>
        ))}
        {disabled && value && (
          <StyledMenuItem value={value}>{value}</StyledMenuItem>
        )}
      </StyledNativeSelect>
    </FieldContainer>
  );
};

export default Select;
